import { render, staticRenderFns } from "./ChatIslandMount.vue?vue&type=template&id=62b7c008"
import script from "./ChatIslandMount.vue?vue&type=script&lang=js"
export * from "./ChatIslandMount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports